<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><i>Contents</i></p>
<p class="toc1"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Death of the Secret Service Man</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Bad Blood on Bear Creek</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Grave Misfortune of Kid Adams, the Ouray Highwayman</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Dangerous Women</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Durango Desperadoes: Porter and Ike Stockton</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Tragic Tale of Mary Rose and the Cuddigans</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Famous and Infamous Days of the San Juans</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. A Colorado Range War: The Cox-Truby Feud</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. “The Utes Must Go”</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Wild and Wonderful Circle Route Stage</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. “White-Capping” in the San Juans</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Tragedy at Pine River</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Sheriff and Marshal Shoot It Out</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. The High Price of Being (and Killing) a Gentleman</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?45cf0db2